import styled from 'styled-components';

export const Claim = styled.span`
  margin: 50px 0 0 30px;
  display: block;
  font-size: 2.2em;
  font-weight: bold;
  letter-spacing: 0.5px;
  color: #4a4a4a;
`;
